import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';

import {
    createGptSizeMapping,
    mapDeviceNameToViewport
} from 'static/script/app/ui/layout/ads/ad-slot-utilities';
import ApplicationErrorBoundary from 'tradera-components/application-error-boundary';
import LocalizedDfpAd from 'tradera-components/ads/localized-dfp-ad';
import MediaQuery from 'react-responsive';

const Ad = props => {
    const adContainerRef = useRef();
    const {
        adContainerClass,
        adFormats,
        autoscale,
        autoscaleOffsetWidth,
        className,
        children,
        deviceName,
        featureSwitches,
        gpt,
        position,
        refresh,
        stickyBottom,
        stickyEnabled,
        stickyTop,
        ...otherProps
    } = props;
    const canCreateDfpAd = gpt?.adUnitPath;
    const [sizeMapping] = useState(createGptSizeMapping(adFormats, deviceName));
    const [minViewportWidth, maxViewportWidth] = mapDeviceNameToViewport(
        deviceName
    );
    if (canCreateDfpAd) {
        return (
            <MediaQuery
                minWidth={minViewportWidth}
                maxWidth={maxViewportWidth || undefined}>
                <div
                    className={`ad-slot-container ${className}`}
                    ref={adContainerRef}
                    {...otherProps}>
                    <ApplicationErrorBoundary capture={false}>
                        <LocalizedDfpAd
                            adUnitPath={gpt.adUnitPath}
                            pageTargeting={gpt?.customTargetingParameters}
                            adContainerClass={adContainerClass}
                            autoscale={autoscale}
                            autoscaleOffsetWidth={
                                autoscale === true
                                    ? autoscaleOffsetWidth ||
                                      adContainerRef?.current?.offsetWidth
                                    : undefined
                            }
                            maxViewportWidth={maxViewportWidth}
                            minViewportWidth={minViewportWidth}
                            refresh={featureSwitches['ads-refresh'] && refresh}
                            sizeMapping={sizeMapping}
                            slotTargeting={{ pos: position }}
                            stickyBottom={stickyBottom}
                            stickyEnabled={stickyEnabled}
                            stickyTop={stickyTop}>
                            {children /* Placeholder for ad */}
                        </LocalizedDfpAd>
                    </ApplicationErrorBoundary>
                </div>
            </MediaQuery>
        );
    } else {
        return null;
    }
};

const mapStateToProps = state => ({
    featureSwitches: state.environment.featureSwitches,
    gpt: state.ads.gpt
});

export default connect(mapStateToProps, () => ({}))(Ad);
